import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { connect } from 'react-redux';
import AdminDashboard from '../../../components/SiteAdmin/AdminDashboard/AdminDashboard';
import Loader from '../../../components/Common/Loader/Loader';
import { adminLogout } from '../../../actions/siteadmin/logout';
import { earningConverter } from '../../../helpers/earningConverter';
import getDashboardCountQuery from './getDashboardCount.graphql';
import getAdminUserQuery from './GetAdminUser.graphql';
import useQueryResponse from '../../../lib/hooks/useQueryResponse';

const Dashboard = ({ title, adminLogout, base, rates }) => {

  const { loading: loadingDashboard, data: dashboardData } = useQueryResponse({
    query: getDashboardCountQuery,
    fetchPolicy: 'network-only',
  });

  const { data: adminData } = useQuery(getAdminUserQuery, {
    fetchPolicy: 'network-only',
    ssr: false,
    onCompleted: (data) => {
      if (data?.getAdminUser?.result === null) {
        adminLogout();
      }
    }
  });

  const earnings = dashboardData?.getDashboardCount;
  const loading = loadingDashboard;

  let todayEarnings = 0, weeklyEarnings = 0, monthlyEarnings = 0, totalEarnings = 0;
  if (earnings) {
    const earningData = earningConverter({ earnings, base, rates });
    todayEarnings = earningData?.todayEarningsValue;
    weeklyEarnings = earningData?.weeklyEarningsValue;
    monthlyEarnings = earningData?.monthlyEarningsValue;
    totalEarnings = earningData?.totalEarningsValue;
  }

  return (
    <Loader type="page" show={loading}>
      {!loading && (
        <AdminDashboard
          title={title}
          getDashboardCount={earnings}
          todayEarnings={todayEarnings}
          weeklyEarnings={weeklyEarnings}
          monthlyEarnings={monthlyEarnings}
          totalEarnings={totalEarnings}
        />
      )}
    </Loader>
  );
};

Dashboard.propTypes = {
  title: PropTypes.string.isRequired,
  adminLogout: PropTypes.func.isRequired,
  base: PropTypes.string,
  rates: PropTypes.object,
};

const mapState = (state) => ({
  base: state.currency.base,
  rates: state.currency.rates,
});

const mapDispatch = {
  adminLogout,
};

export default connect(mapState, mapDispatch)(Dashboard);
